<template>
  <div class="statistics-warpper">
    <div class="bg-white">
      <twoLevel @SearchInfo="SearchInfo"/>
      <div class="flex align-center justify-between margin-top-sm">
        <div class="statistics-item">
          <div class="item-title active1"><img src="../../assets/img/ps1.png" alt="">应收物业费金额</div>
          <div class="item-info total-all">
            <b>{{ yinShouWuYeFei }}</b>元
          </div>
        </div>
        <div class="statistics-item">
          <div class="item-title active2"><img src="../../assets/img/ps2.png" alt="">缴纳物业费</div>
          <div class="item-info">
            <div class="item-num">
              <p>金额（元）</p>
              <h3>{{ shiShouWuYeFei }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>收缴率</p>
              <h3>{{ jiaoNaLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="statistics-item">
          <div class="item-title active3"><img src="../../assets/img/ps3.png" alt="">物业费</div>
          <div class="item-info">
            <div class="item-num">
              <p>总缴纳户数</p>
              <h3>{{ zongJiaoNaHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>缴纳率</p>
              <h3>{{ shouFeiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="statistics-item">
          <div class="item-title active4"><img src="../../assets/img/ps4.png" alt="">未缴纳</div>
          <div class="item-info">
            <div class="item-num">
              <p>未缴纳户数</p>
              <h3>{{ weiJiaoNaHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>未缴纳率</p>
              <h3>{{ weiJiaoNaLv }}%</h3>
            </div>
          </div>
        </div>
        <!-- <div class="statistics-item">
          <div class="item-title active5"><img src="../../assets/img/ps5.png" alt="">延期缴纳</div>
          <div class="item-info">
            <div class="item-num">
              <p>延期缴纳户数</p>
              <h3>256</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>延期率</p>
              <h3>75%</h3>
            </div>
          </div>
        </div>-->
      </div>
      <div v-if="buildingList.length>0">
        <div class="flex align-center justify-end margin-tb">
          <div class="tagging-item"><i class="active1"></i> <span>已缴纳物业费</span></div>
          <div class="tagging-item"><i class="active2"></i> <span>未缴纳物业费</span></div>
          <!--        <div class="tagging-item"><i class="active3"></i> <span>延期缴纳物业费</span></div>-->
        </div>

        <div v-for="building in buildingList" :key="building.id">
          <div class="font-size flex align-center justify-between building-name "
               @click="building.open = !building.open">
            <h3>{{ building.building_name }}分布图 <span>（{{ building.element_list.length }}个单元）</span></h3>
            <p class="margin-left">{{ building.open ? '收起' : '展开' }}</p>
          </div>

          <div class="" v-if="building.open">
            <div class="w-100 padding-tb-xs" v-for="item in building.element_list" :key="item.id">
              <div class="unit-scroll flex align-start flex-wrap">
                <div class="  unit-box"
                     :style="{width:(item.chuan_index*150+1) + 'px'} ">
                  <div class="flex align-center">
                    <div v-for="(chuan,cindex) in item.chuan_index" :key="cindex" class="unit-item active"
                         style="width: 150px">
                      {{ chuan }}串
                    </div>
                  </div>
                  <div class="flex align-center flex-wrap">
                    <div v-for="room in item.room_list" :key="room.id" class="unit-item" style="width: 150px">
                      <p>{{ building.building_name + '-' + item.element_name + '-' + room.room_name }}</p>

                      <i class="active2" v-if="Number(room.yj_wuyefei) === 0 "></i>
                      <i class="active1" v-else></i>

                    </div>
                  </div>
                  <div class="unit-name">{{ item.element_name }}</div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>


    </div>
  </div>
</template>

<script>
import twoLevel from '@/components/two-level'
import {wuYeTongJiOne, wuYeTongJiTwo} from "@/api/statistics";
import {zhDate} from "@/utils/utils";

export default {
  name: "property-statistics",
  data() {
    return {
      jiaoNaLv: 0,
      shiShouWuYeFei: 0,
      shouFeiLv: 0,
      weiJiaoNaHuShu: 0,
      weiJiaoNaLv: 0,
      yinShouWuYeFei: 0,
      zongJiaoNaHuShu: 0,
      buildingList: []
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "物业统计", false);
  },
  components: {
    twoLevel
  },
  methods: {
    async SearchInfo(val) {
      let _data = await wuYeTongJiOne(
          val.project,
          val.community,
          zhDate(new Date(),4)
      )
      console.log(_data)
      this.jiaoNaLv = (_data.data.jiaoNaLv *100).toFixed(2)
      this.shiShouWuYeFei = _data.data.shiShouWuYeFei
      this.shouFeiLv = (_data.data.shouFeiLv *100).toFixed(2)
      this.weiJiaoNaHuShu = _data.data.weiJiaoNaHuShu
      this.weiJiaoNaLv = (_data.data.weiJiaoNaLv *100).toFixed(2)
      this.yinShouWuYeFei = _data.data.yinShouWuYeFei
      this.zongJiaoNaHuShu = _data.data.zongJiaoNaHuShu
      if (val.community) {
        let _list = await wuYeTongJiTwo(val.project, val.community,zhDate(new Date(),4))
        _list.data.map(item=>{
          item.open = true
        })
        this.buildingList = _list.data
      } else {
        this.buildingList = []
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

.statistics-warpper {
  .statistics-item {
    flex-basis: 24%;
    height: 170px;
    background-color: #ffffff;
    box-shadow: 0px 0px 19px 0px rgba(175, 181, 193, 0.47);
    border-radius: 8px;

    .item-title {
      display: flex;
      align-items: center;
      padding-left: 20px;
      height: 40px;
      font-size: 18px;
      color: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      &.active1 {
        background-color: #1bb2cd;
      }

      &.active2 {
        background-color: #2587ff;
      }

      &.active3 {
        background-color: #4cb6bf;
      }

      &.active4 {
        background-color: #bf984c;
      }

      &.active5 {
        background-color: #be3600;
      }

      img {
        margin-right: 10px;
      }
    }

    .item-info {
      display: flex;
      align-items: center;
      height: 130px;

      &.total-all {
        justify-content: center;
        font-size: 16px;

        b {
          font-size: 32px;
          margin-right: 5px;
        }
      }

      .item-num {
        width: 48%;
        height: 52px;
        text-align: center;

        p {
          font-size: 14px;
          color: #999;
          line-height: 150%;
        }

        h3 {
          font-size: 24px;
          line-height: 150%;
        }
      }

      i {
        display: block;
        width: 1px;
        height: 52px;
        border: dashed 1px #cccccc;
        opacity: 0.5;
      }
    }
  }

  .tagging-item {
    display: flex;
    align-items: center;
    margin-left: 30px;

    i {
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin-right: 10px;

      &.active1 {
        background-color: #1bb2cd;
      }

      &.active2 {
        background-color: #bf984c;
      }

      &.active3 {
        background-color: #be3600;
      }
    }
  }

  .building-name {
    cursor: pointer;
    padding: 10px;

    span {
      font-weight: normal;
      color: #999;
      font-size: 14px;
    }

    p {
      color: #d00000;
      font-weight: normal;
      font-size: 14px;
    }
  }

  .unit-scroll {
    width: 100%;
    overflow: auto;

    .unit-box {
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      box-sizing: border-box;

      .unit-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 150px;
        height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;

        &.active {
          background: #eee;
          justify-content: center;
        }

        p {
          flex: 1;
          text-align: center;
        }

        i {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 10px;

          &.active1 {
            background-color: #1bb2cd;
          }

          &.active2 {
            background-color: #bf984c;
          }

          &.active3 {
            background-color: #be3600;
          }
        }
      }

      .unit-name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        color: #d00000;
        border: 1px solid #eeee;
        border-top: 0;
        font-weight: bold;
      }
    }
  }
}
</style>